var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pro"},[(_vm.percent)?_c('div',{staticClass:"progress-b"},[_c('b-progress',{staticClass:"prog",attrs:{"value":_vm.percent,"max":100,"animated":"","height":"10"}})],1):_vm._e(),(_vm.percent)?_c('div',{staticClass:"persent"},[_vm._v(_vm._s(_vm.percent)+"%")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }